/**
 * PlayerPreviewDrawer — the player preview opened by clicking a board card
 * (SE-5494). Replaces the four-row `PlayerDetailsSidebar` it supersedes.
 * @module features/player-kanban/components/organisms/PlayerPreviewDrawer
 */

export { default } from "./PlayerPreviewDrawerContainer";
export type { PlayerPreviewDrawerContainerProps } from "./PlayerPreviewDrawerContainer";
export type {
  PlayerPreviewPinnedNote,
  PlayerPreviewTag,
} from "./PlayerPreviewDrawerView";
